import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService } from '../feature-flag.service';

export const featureFlagGuard: CanActivateFn = async (route) => {
  const featureFlagService = inject(FeatureFlagService);
  const router = inject(Router);
  const flag = route.data['featureFlag'] as string | undefined;

  if (!flag) {
    return true;
  }

  const enabled = await featureFlagService.isEnabledAsync(flag);
  if (!enabled) {
    router.navigate(['/']);
    return false;
  }

  return true;
};
